export interface IPatientRisk {
  id: number;
  code: string;
  description: string | null;
  member_name: string;
  inactive: boolean;
  present: boolean;
  treated_provider_id: number | null;
  app: boolean;
  ehr: boolean;
  claim: boolean;
  hcc_category: string | null;
  hcc_description: string | null;
}

export interface IResultPatientRisk {
  count: number;
  next: string | null;
  previous: string | null;
  results: IPatientRisk[];
}

export class PatientRisk {
  id: number;
  code: string;
  description: string | null;
  memberName: string;
  inactive: boolean;
  present: boolean;
  treatedProviderId: number | null;
  app: boolean;
  ehr: boolean;
  claim: boolean;
  hccCategory: string | null;
  hccDescription: string | null;

  constructor(risk: IPatientRisk) {
    this.id = risk.id;
    this.code = risk.code;
    this.description = risk.description;
    this.memberName = risk.member_name;
    this.inactive = risk.inactive;
    this.present = risk.present;
    this.treatedProviderId = risk.treated_provider_id;
    this.app = risk.app;
    this.ehr = risk.ehr;
    this.claim = risk.claim;
    this.hccDescription = risk.hcc_description;
    this.hccCategory  = risk.hcc_category;
  }

  static fromObject(risk: IPatientRisk): PatientRisk {
    return new PatientRisk(risk);
  }

  static fromObjectArray(risks: IPatientRisk[]): PatientRisk[] {
    return risks.map(risk => new PatientRisk(risk));
  }
}

export class PatientRiskResult {
  count: number;
  next: string | null;
  previous: string | null;
  results: PatientRisk[];

  constructor(result?: IResultPatientRisk) {
    this.count = result?.count ?? 0;
    this.next = result?.next ?? null;
    this.previous = result?.previous ?? null;
    this.results = result ? PatientRisk.fromObjectArray(result.results) : [];
  }

  static fromObject(result: IResultPatientRisk): PatientRiskResult {
    return new PatientRiskResult(result);
  }
}
